<template>
    <b-row>
        <b-col>
            <b-row id="filters-row">
                <input type="text" class="btn-search" placeholder="🔎 Pesquise por nome ou telefone"
                    v-model="searchInput">

                <div class="type-filter">
                    <v-select id="city-search" v-model="groupSelect" :options="optionsGroups"></v-select>
                </div>
            </b-row>

            <b-row>
                <b-table striped hover sticky-header fixed head-variant="dark" :items="items" :fields="fields">
                    <template v-slot:cell(action)="data">
                        <button v-show="!!data.item.check === true" class="btn btn-danger btn-table"
                            @click="delItem(data)"><i class="fas fa-times"></i> Remover</button>

                        <button v-show="!!data.item.check === false" class="btn btn-primary btn-table"
                            @click="addItem(data)"><i class="fas fa-plus"></i> Adicionar</button>
                    </template>
                </b-table>
            </b-row>

            <b-row id="count-row">
                <div id="total-count">
                    TOTAL: <b>{{ totalChecked }}</b> contato<span v-show="totalChecked > 1">s</span> adicionado<span
                        v-show="totalChecked > 1">s</span>.
                </div>

                <div class="add-or-remove-all">
                    <button class="btn btn-primary" @click="addAll()">Adicionar todos</button>
                    <button class="btn btn-danger" @click="delAll()">Remover todos</button>
                </div>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
export default {
    props: {
        wallets: {
            type: Array,
            default: () => []
        },
        groups: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            at_wallets: this.wallets,
            groupSelect: 'Todos os grupos',
            searchGrupo: 0,
            optionsGroups: [],
            elementos: 1,
            items: [],
            searchInput: '',
            fields: [
                {
                    key: 'name',
                    label: 'NOME',
                    class: 'text-center align-middle',
                    sortable: true,
                    thStyle: { width: '200px' }
                },
                {
                    key: 'phone',
                    label: 'TELEFONE',
                    class: 'text-center align-middle',
                    sortable: true
                },
                {
                    key: 'msg_group',
                    label: 'GRUPO',
                    class: 'text-center align-middle',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'AÇÃO',
                    class: 'text-center align-middle',
                    sortable: true,
                    thStyle: { width: '120px' }
                },
            ],
        }
    },
    methods: {
        addItem(data) {
            const selected = this.items.filter(el => el.check);
            if (selected.length >= 900) {
                Swal.fire({
                    type: 'error',
                    title: 'Maximo de clientes selecionados!',
                    text: "Não é possível selecionar mais de 900 clientes."
                });
                return;
            }
            data.item.check = true
            const { name, phone } = data.item
            this.$emit('addClient', { name, phone });

        },
        delItem(data) {
            data.item.check = false
            const { name, phone } = data.item
            this.$emit('removeClient', { name, phone });
        },
        addAll() {
            const selected = this.items.filter(el => el.check);
            if (selected.length < 900) {
                const maxItems = this.items.length < 900 ? this.items.length : 900;
                for (let index = selected.length; index < maxItems; index++) {
                    this.items[index].check = true;
                    const { name, phone } = this.items[index];
                    this.$emit('addClient', { name, phone });
                }
            }
        },
        delAll() {
            this.items.forEach(item => {
                item.check = false
            });
            this.$emit('removeAllClients');
        },
    },
    computed: {
        totalChecked() {
            let total = 0;
            this.wallets.forEach(el => {
                if (!!el.check) total++
            });
            return total;
        },
    },
    watch: {
        groupSelect(value) {
            if (value != null && value != '' && value != 'Todos os grupos') {
                this.items = this.at_wallets.filter(el => {
                    return el.msg_group == value;
                });
            } else {
                this.items = this.at_wallets;
                this.searchGrupo = 0;
            }
        },
        searchInput() {
            let keyword = this.searchInput?.toLowerCase();
            this.groupSelect = 'Todos os grupos';
            this.items = this.at_wallets.filter(row => {
                const name = row.name?.toLowerCase();
                const phone = row.phone;
                return (name?.includes(keyword) ||
                    phone?.includes(keyword)
                )
            })
        },
    },
    async created() {
        const { data: getGroups } = await axios.get('/marketing/getActiveGroups');
        this.optionsGroups = getGroups;
        this.items = this.at_wallets;
    }

}
</script>

<style scoped>
#city-search {
    width: 200px;
}

#filters-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 5px 0px 5px 0px;
}

#count-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 10px;
}

#total-count {
    align-self: center;
}

td {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 1px;
}

.b-table-sticky-header {
    max-height: 35vh;
}

.add-or-remove-all button {
    border-radius: 10px !important;
}

.btn-table {
    border-radius: 10px !important;
    font-size: 10px;
    margin: 0px;
}

.btn-search {
    width: 50%;
    padding: 0.3rem 0.75rem;
    border: 1px solid #ced4da;
    border-radius: 4px !important;
    outline: none;
}

.btn-search:focus {
    border: 1px solid #a0a4a8;
}
</style>